
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M285.172 331.453c-12.453 13.25-20.547 18.781-26.094 18.781-3.859 0-5.172-3.422-4.312-11.142 2.593-20.062 17.531-84.578 21.781-107.625 4.266-19.719 3-29.953-2.562-29.953-10.641 0-36.733 17.516-53.827 35.016-.875 1.344-2.562 8.578-1.688 11.125 0 .875 1.266 1.312 1.266 1.312 10.266-8.125 18.391-12.844 23.109-12.844 2.109 0 2.938 3.406 1.688 9.406-5.125 25.625-13.672 65.405-20.078 98.28-5.984 28.672-2.172 40.188 6.812 40.188s33.766-11.983 53.906-38.906c.812-2.094 1.641-10.188 1.25-12.358-.001-.827-1.251-1.28-1.251-1.28zM281.281 128c-7.297 0-16.25 3.414-20.516 7.703-1.688 2.141-3.406 8.539-3.859 11.945.453 7.711 2.578 11.984 6.859 14.562 2.108 1.68 16.219.414 19.219-1.312 5.188-3.398 9.828-10.25 10.703-18.375.375-3.82-.438-8.984-2.142-11.531-.857-1.273-4.295-2.992-10.264-2.992z"}}),_c('path',{attrs:{"d":"M256 0C114.609 0 0 114.609 0 256c0 141.391 114.609 256 256 256 141.391 0 256-114.609 256-256C512 114.609 397.391 0 256 0zm0 472c-119.297 0-216-96.703-216-216S136.703 40 256 40s216 96.703 216 216-96.703 216-216 216z"}})])
          )
        }
      }
    